import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@rsos/components/capstone/base';
import Select from '@rsos/components/capstone/base/Select';
import { useFlag } from '@rsos/flags';
import { Label } from '../AirAmbulanceFormStandalone.styles';
import { useLandingZonesLayer } from '../hooks';

const LandingZoneSelect = ({
  setFieldValue,
  handleChange,
  handleLandingZoneSelect,
  selectedLandingZone,
}) => {
  const isGmrLandingZoneEnabled = useFlag('gmr_landing_zone');
  const { spatialObjects } = useLandingZonesLayer();

  const spatialObjectOptions = useMemo(() => {
    if (!spatialObjects || !Array.isArray(spatialObjects)) return [];
    return spatialObjects;
  }, [spatialObjects]);

  const selectedOption = useMemo(() => {
    if (!selectedLandingZone) return null;
    return (
      spatialObjectOptions.find(obj => obj?.id === selectedLandingZone?.id) ||
      null
    );
  }, [spatialObjectOptions, selectedLandingZone]);

  const handleSpatialObjectSelect = selectedOption => {
    handleLandingZoneSelect(selectedOption, setFieldValue, handleChange);
  };

  // Only render if the feature flag is enabled and there are spatial objects
  if (!isGmrLandingZoneEnabled || !spatialObjectOptions.length) {
    return null;
  }

  return (
    <Box pb={3}>
      <Label>
        <Text size="small" color="primaryText">
          Landing Zone
        </Text>
      </Label>
      <Select
        options={spatialObjectOptions}
        getOptionLabel={option => option?.name || ''}
        getOptionValue={option => String(option?.id ?? '')}
        value={selectedOption}
        placeholder="Select a landing zone..."
        onChange={handleSpatialObjectSelect}
        isClearable={true}
        isSearchable={true}
      />
    </Box>
  );
};

LandingZoneSelect.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleLandingZoneSelect: PropTypes.func.isRequired,
  selectedLandingZone: PropTypes.object,
};

export default LandingZoneSelect;
